// ค่าคอนฟิกจาก Vite env (build-time) — ไม่มี .env ในโค้ด
export const LIFF_ID = import.meta.env.VITE_LIFF_ID || '';
export const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:8787';

// mock mode: ตอน dev ในเบราว์เซอร์ธรรมดา ยังไม่มี LINE → ใช้โปรไฟล์ปลอม
// production build ต้องเป็น 0 เสมอ (เทสต์บนไลน์จริง)
export const MOCK = import.meta.env.VITE_MOCK === '1';

export const MOCK_PROFILE = {
  userId: 'U_mock_0001',
  displayName: 'ทดสอบ น้องจมูก',
  pictureUrl: '',
};
